import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NumberWithTwoDecimalsDirective } from './number-with-two-decimals.directive';
import { TrimTextDirective } from './trim-text.directive';
import { SpecialCharactersDirective } from './special-characters.directive';
import { PhoneNumberDirective } from './phone-number.directive';
import { DniCifDirective } from './dni-cif.directive';
import { CodeTextDirective } from './code-text.directive';
import { NumberDirective } from './number.directive';
import { ProjectNameDirective } from './project-name.directive';
import { AddressDirective } from './address.directive';
import { IdStringDirective } from './id-string.directive';
import { UpperCaseDirective } from './upper-case.directive';

/**
 * Colección de directivas de la página
 */
@NgModule({
  imports: [
    CommonModule,
  ],
  declarations: [
    NumberWithTwoDecimalsDirective,
    TrimTextDirective,
    SpecialCharactersDirective,
    PhoneNumberDirective,
    DniCifDirective,
    CodeTextDirective,
    NumberDirective,
    ProjectNameDirective,
    AddressDirective,
    IdStringDirective,
    UpperCaseDirective
  ],
  exports: [
    NumberWithTwoDecimalsDirective,
    TrimTextDirective,
    SpecialCharactersDirective,
    PhoneNumberDirective,
    DniCifDirective,
    CodeTextDirective,
    NumberDirective,
    ProjectNameDirective,
    AddressDirective,
    IdStringDirective,
    UpperCaseDirective
  ],
})

export class DirectivesModule { }
